<template>
   <teleport to="#modals">
      <modal
         title="Opslaan en delen per e-mail"
         ref="modalRef"
      >
         <template v-slot:content>
            <p class="my-6">
               Deel je samengestelde set per e-mail met bijvoorbeeld jezelf, je partner of je collega. Je kunt de cilinderset later nog
               aanpassen of direct bestellen.
            </p>
            <!-- <p class="my-6">Deel uw samengestelde set per e-mail met uw partner of collega. U kunt de cilinderset later nog aanpassen of meteen bestellen.</p> -->
            <form @submit.prevent="submit">
               <div>
                  <label
                     for="email"
                     class="block text-sm h-5 font-semibold text-gray-700"
                     >E-mail</label
                  >
                  <div class="mt-1">
                     <input
                        id="email"
                        name="email"
                        type="email"
                        autocomplete="email"
                        v-model="email"
                        class="text-input"
                        placeholder="naam@voorbeeld.nl"
                        :class="{ 'text-input-failed': !email && form.errors?.email }"
                     />
                     <transition name="pop">
                        <div
                           class="error-text"
                           v-if="!email && form.errors?.email"
                        >
                           {{ form.errors?.email }}
                        </div>
                     </transition>
                  </div>
               </div>
               <div class="mt-6">
                  <div class="w-full">
                     <div class="flex items-center space-x-6">
                        <fa
                           :icon="['fal', 'phone']"
                           class="text-dgreen h-6 w-6 p-6 flex justify-center text-center rounded-full border border-dgreen/30 bg-dgreen/5"
                        />
                        <div>
                           <p class="text-sm text-gray-600">
                              Heb je nog vragen of wil je graag meer advies? Laat je telefoonnummer en een geschikte beltijd achter, dan
                              bellen we je graag terug voor een persoonlijk gesprek.
                           </p>
                           <div class="flex items-center space-x-2 mt-2">
                              <input
                                 type="checkbox"
                                 class="h-4 w-4 border-gray-400 rounded text-blue-600 transition focus:ring-0"
                                 v-model="call"
                                 id="call"
                              />
                              <label
                                 for="call"
                                 class="ml-2 cursor-pointer no-select"
                                 >Ik wil graag teruggebeld worden</label
                              >
                           </div>
                        </div>
                     </div>
                  </div>

                  <!--  -->
                  <!-- <input type="checkbox" id="phone" name="phone" v-model="phone" class="text-input" /> -->
                  <transition name="pop">
                     <div
                        class="mt-3 w-full"
                        v-if="call"
                     >
                        <label
                           for="phone"
                           class="block text-sm h-5 font-semibold text-gray-700 my-1"
                           >Telefoonnummer</label
                        >
                        <input
                           type="tel"
                           name="phone"
                           id="phone"
                           autocomplete="billing tel"
                           placeholder="06 123456789"
                           v-model="phone"
                           class="text-input"
                           :class="{ 'text-input-failed': !phone && form.errors?.phone }"
                        />
                        <transition name="pop">
                           <div
                              class="error-text"
                              v-if="!email && form.errors?.phone"
                           >
                              {{ form.errors?.phone }}
                           </div>
                        </transition>

                        <div class="w-full flex flex-wrap mt-4">
                           <label
                              for="pickup_day"
                              class="w-full block text-sm h-5 font-semibold text-gray-700"
                              >Tijdstip</label
                           >

                           <RadioGroup
                              v-model="time"
                              class="w-full my-2"
                           >
                              <!-- <RadioGroupLabel class="sr-only"> Privacy setting </RadioGroupLabel> -->
                              <div class="bg-white rounded-md -mx-1 flex flex-wrap">
                                 <RadioGroupOption
                                    v-for="(timeLabel, key) in times"
                                    :key="key"
                                    :value="key"
                                    v-slot="{ checked }"
                                    class=""
                                 >
                                    <div class="px-1 pb-2">
                                       <div
                                          :class="[checked ? 'bg-blue-50 border-blue-200 z-10' : 'border-gray-200']"
                                          class="relative rounded-md border p-3 cursor-pointer focus:outline-hidden hover:bg-slate-50"
                                       >
                                          <RadioGroupLabel
                                             as="span"
                                             class="items-center block text-sm font-medium text-center"
                                          >
                                             {{ timeLabel }}
                                          </RadioGroupLabel>
                                       </div>
                                    </div>
                                 </RadioGroupOption>
                              </div>
                           </RadioGroup>
                        </div>
                     </div>
                  </transition>
               </div>
               <button
                  type="submit"
                  :disabled="loading"
                  class="button green w-full mt-6"
               >
                  <fa
                     :icon="['fad', 'spinner-third']"
                     class="text-white opacity-80 mr-2 fa-spin"
                     v-if="loading"
                  />
                  Verzenden
               </button>
            </form>
         </template>
      </modal>
   </teleport>
</template>

<script setup>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { useForm, usePage } from '@inertiajs/vue3'
import { ref } from 'vue'

const inBrowser = typeof window !== 'undefined'
const ab_variant = usePage().props.ab_variant

const props = defineProps({
   product: {
      type: Object,
      required: true,
   },
   form: {
      type: Object,
      required: true,
   },
})

const inertiaForm = useForm(props.form)
const modalRef = ref(null)
const phone = ref('')
const call = ref(false)
const loading = ref(false)
const time = ref('asap')
const email = ref(usePage().props.user?.email || '')

const times = {
   asap: 'Zo snel mogelijk',
   today1012: '10:00 - 12:00',
   today1316: '13:00 - 16:00',
}

function showModal() {
   modalRef.value.open = true
}

function hideModal() {
   modalRef.value.open = false
}

async function submit() {
   loading.value = true

   try {
      const response = await inertiaForm
         .transform((data) => ({
            ...data,
            email: email.value,
            cylinders: props.form.cylinders,
            keys: props.form.keys,
            id: props.product.id,
            time: time.value,
            phone: phone.value,
         }))
         .post('/configuration/quote', {
            preserveScroll: true,
         })

      if (inBrowser) {
         dataLayer.push({
            event: 'shared_product',
            ab_variant: ab_variant,
            product_id: props.product.id,
         })
      }

      if (!props.form.errors?.email) {
         hideModal()
      }
   } catch (error) {
      console.error('Error submitting form:', error)
   } finally {
      loading.value = false
   }
}

defineExpose({
   showModal,
   hideModal,
})
</script>
